import React, {useState, useEffect, useCallback, useContext} from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
  Card,
  Table,
  Stack,
  Button,
  Checkbox,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Box,
  Chip,
  useTheme,
  useMediaQuery
} from '@mui/material';

import { camelCase } from 'lodash'

// components
import Iconify from '../iconify';
import Scrollbar from '../scrollbar';
// sections
import { EnvelopeListHead, EnvelopeListToolbar } from '../../sections/@dashboard/envelope/index';

import {EntityContext} from '../../entity'

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Nome', alignRight: false },
  { id: 'action', label: '', alignRight: false },
];

const TABLE_HEAD_SIMPLE = [
  { id: 'name', label: 'Nome', alignRight: false },
  { id: 'action', label: '', alignRight: false },
];


export default function FileInput(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { getEnvelope, createDocument, vinculateDocumentToEnvelope, removeDocumentToEnvelope } = useContext(EntityContext)

    const [page, setPage] = useState(0);

    const [selected, setSelected] = useState([]);

    const [rowsPerPage, setRowsPerPage] = useState(5);

	const [fileList, setFilelist] = useState([]);
    const [base64List, setBase64list] = useState([]);

	const envelopeKey = props.envelopeKey

	const camelizeKeys = (obj) => {

		let finalResponse = obj

		if (Array.isArray(obj)) {
			finalResponse = obj.map(v => camelizeKeys(v));
		} else if (obj != null && obj.constructor === Object) {
			finalResponse = Object.keys(obj).reduce(
			(result, key) => ({
			  ...result,
			  [camelCase(key)]: camelizeKeys(obj[key]),
			}),
			{},
		  );
		}
		return finalResponse;
	  };
	
	const getDocuments = useCallback(async () => {
	
    getEnvelope(envelopeKey)
        .then((data) => {
          
          setFilelist(data.documents)
        })
	
	  }, [envelopeKey])



    function getExtension(filename) {
        const parts = filename.split('.');
        return parts[parts.length - 1];
    }

    function isPdf(filename) {
        const ext = getExtension(filename);

        switch (ext.toLowerCase()) {
            case 'pdf':
                return true
            default:
                return false
        }

      }

    const changeHandler = async (event) => {

      const newDoc = event.target.files[0]

      const validFile = isPdf(newDoc.name) 

      if (validFile) {

        const base64Doc = await convertBase64(newDoc)

        const validBase64Doc = base64Doc.split(',')
        

        const newDocumentRecord = await createDocument(newDoc.name, validBase64Doc[validBase64Doc.length - 1])

        if(newDocumentRecord) {

          const addedToEnvelope = await vinculateDocumentToEnvelope(newDocumentRecord.documentKey, envelopeKey)

          if(addedToEnvelope) {
            getDocuments()
          }

        }
      }

    };

    const handleSubmission = async () => {

		if (fileList.length === 0) {
			
			props.changeStep(1)

		} else {
	
			props.changeStep(2)

		}

    };

	useEffect(() => {
		getDocuments()
	  }, [])

      const removeFileFromEnvelope = async (documentKey) => {
        removeDocumentToEnvelope(documentKey, props.envelopeKey)
        .then((response) => {
            getDocuments()
        })
      }

    const convertBase64 = (file) => {
            return new Promise((resolve, reject) => {
            const fileReader = new FileReader()

            fileReader.readAsDataURL(file)

            fileReader.onload = () => {
                resolve(fileReader.result);
            }

            fileReader.onError = (error) => {
                reject(error)
            }

        })
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
        const newSelecteds = fileList.map((n) => n.name);
        setSelected(newSelecteds);
        return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - fileList.length) : 0;

    return (
        <>
        <Helmet>
            <title> Documentos </title>
        </Helmet>

        <Box>
            {/* Botões de ação - responsivos */}
            <Stack 
                direction={{ xs: 'column', sm: 'row' }} 
                spacing={2}
                alignItems={{ xs: 'stretch', sm: 'center' }}
                justifyContent="space-between" 
                mb={3}
            >
                <Button 
                    variant="contained" 
                    component="label" 
                    startIcon={<Iconify icon="eva:plus-fill" />}
                    fullWidth={isMobile}
                    sx={{ 
                        minWidth: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap'
                    }}
                >
                    Adicionar Documento
                    <input 
                        hidden 
                        accept="application/pdf" 
                        multiple 
                        type="file" 
                        name="file"
                        onChange={changeHandler}
                    />
                </Button>
                <Button 
                    variant="contained"
                    onClick={handleSubmission}
                    fullWidth={isMobile}
                    sx={{ 
                        minWidth: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap'
                    }}
                >
                    Adicionar Signatários
                </Button>
            </Stack>

            <Card>
                {isMobile ? (
                    <>
                        {/* Vista mobile: Cards sem checkbox, busca e filtro */}
                        <Box sx={{ p: 2 }}>
                            {fileList.length === 0 ? (
                                <Stack alignItems="center" spacing={2} py={4}>
                                    <Iconify icon="eva:file-outline" sx={{ fontSize: 48, color: 'text.disabled' }} />
                                    <Typography variant="body2" color="text.secondary" align="center">
                                        Nenhum documento adicionado ainda
                                    </Typography>
                                </Stack>
                            ) : (
                                <List>
                                    {fileList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                        return (
                                            <React.Fragment key={row.id}>
                                                <ListItem
                                                    sx={{
                                                        borderRadius: 1,
                                                        mb: 1,
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        bgcolor: 'background.paper'
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="subtitle2" fontWeight="medium">
                                                                {row.document_name}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Chip 
                                                                label="PDF" 
                                                                size="small" 
                                                                color="primary" 
                                                                variant="outlined"
                                                                sx={{ mt: 0.5 }}
                                                            />
                                                        }
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <IconButton 
                                                            edge="end" 
                                                            color="error" 
                                                            onClick={_ => removeFileFromEnvelope(row.document_key)}
                                                            size="small"
                                                        >
                                                            <Iconify icon={'eva:trash-2-outline'} />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                                {index < fileList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length - 1 && <Divider />}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            )}
                        </Box>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={fileList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                        />
                    </>
                ) : (
                    // Vista desktop: Tabela tradicional sem checkbox, busca e filtro
                    <>
                        <Scrollbar>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {TABLE_HEAD_SIMPLE.map((headCell) => (
                                                <TableCell
                                                    key={headCell.id}
                                                    align={headCell.alignRight ? 'right' : 'left'}
                                                    sx={{
                                                        bgcolor: 'grey.100',
                                                        fontWeight: 'fontWeightBold'
                                                    }}
                                                >
                                                    {headCell.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fileList.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                                                    <Stack alignItems="center" spacing={2}>
                                                        <Iconify icon="eva:file-outline" sx={{ fontSize: 48, color: 'text.disabled' }} />
                                                        <Typography variant="body2" color="text.secondary">
                                                            Nenhum documento adicionado ainda
                                                        </Typography>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            fileList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                                return (
                                                    <TableRow hover key={row.id}>
                                                        <TableCell component="th" scope="row" padding="normal">
                                                            <Typography variant="subtitle2" noWrap>
                                                                {row.document_name}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <IconButton size="large" color="error" onClick={_ => removeFileFromEnvelope(row.document_key)}>
                                                                <Iconify icon={'eva:trash-2-outline'} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        )}
                                        {emptyRows > 0 && (
                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                <TableCell colSpan={2} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={fileList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </>
                )}
            </Card>
        </Box>
        </>
    );
}
